// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"147":"inventario","443":"about","550":"pedidos","919":"pedidoRealizado"}[chunkId] + "." + {"147":"7b23eca3","443":"6b7666d3","550":"702e3cc0","919":"cbfc8f3a"}[chunkId] + ".css";
};